module.exports = __webpack_public_path__ + "static/img/ttopstart.08ba3c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ttopstart.jpg
// module id = MbHo
// module chunks = 1